<script setup>
import { computed, onMounted, ref } from 'vue';
import { useRoute } from 'vue-router';
import Auth from 'dashboard/api/auth';

const route = useRoute();

const copy = {
  title: 'Telegram-\u0431\u043e\u0442\u044b',
  subtitle:
    '\u0418\u0441\u0442\u043e\u0447\u043d\u0438\u043a\u0438 \u043f\u043e\u0434\u0434\u0435\u0440\u0436\u043a\u0438 \u0447\u0435\u0440\u0435\u0437 gateway',
  refresh: '\u041e\u0431\u043d\u043e\u0432\u0438\u0442\u044c',
  newBot: '\u041d\u043e\u0432\u044b\u0439 \u0431\u043e\u0442',
  sources: '\u0418\u0441\u0442\u043e\u0447\u043d\u0438\u043a\u0438',
  countSuffix: '\u0448\u0442.',
  emptyTitle:
    '\u041f\u043e\u043a\u0430 \u043d\u0435\u0442 \u043f\u043e\u0434\u043a\u043b\u044e\u0447\u0435\u043d\u043d\u044b\u0445 \u0431\u043e\u0442\u043e\u0432.',
  emptyText:
    '\u0412\u0441\u0442\u0430\u0432\u044c\u0442\u0435 token \u043e\u0442 @BotFather \u0441\u043f\u0440\u0430\u0432\u0430, \u0438 gateway \u0441\u043e\u0437\u0434\u0430\u0441\u0442 \u0438\u0441\u0442\u043e\u0447\u043d\u0438\u043a \u0432 Chatwoot.',
  createTitle:
    '\u041d\u043e\u0432\u044b\u0439 \u0438\u0441\u0442\u043e\u0447\u043d\u0438\u043a',
  createHint:
    '\u0412\u0441\u0442\u0430\u0432\u044c\u0442\u0435 token \u043e\u0442 @BotFather. \u041d\u0430\u0437\u0432\u0430\u043d\u0438\u0435 \u043c\u043e\u0436\u043d\u043e \u043e\u0441\u0442\u0430\u0432\u0438\u0442\u044c \u043f\u0443\u0441\u0442\u044b\u043c.',
  tokenPlaceholder: 'Bot Token \u043e\u0442 @BotFather',
  brandPlaceholder:
    '\u041d\u0430\u0437\u0432\u0430\u043d\u0438\u0435 \u0431\u0440\u0435\u043d\u0434\u0430',
  createButton:
    '\u0421\u043e\u0437\u0434\u0430\u0442\u044c \u0438\u0441\u0442\u043e\u0447\u043d\u0438\u043a',
  progressTitle:
    '\u041f\u043e\u0434\u043a\u043b\u044e\u0447\u0430\u0435\u043c \u0438\u0441\u0442\u043e\u0447\u043d\u0438\u043a',
  done: '\u0413\u043e\u0442\u043e\u0432\u043e',
  pending: '\u041e\u0436\u0438\u0434\u0430\u0435\u0442',
  error: '\u041e\u0448\u0438\u0431\u043a\u0430',
  connected: '\u041f\u043e\u0434\u043a\u043b\u044e\u0447\u0435\u043d',
  delete: '\u0423\u0434\u0430\u043b\u0438\u0442\u044c',
  deleteConfirm:
    '\u0423\u0434\u0430\u043b\u0438\u0442\u044c @%{username}? Webhook \u0431\u0443\u0434\u0435\u0442 \u0432\u044b\u043a\u043b\u044e\u0447\u0435\u043d, \u0430 \u0431\u043e\u0442 \u0438\u0441\u0447\u0435\u0437\u043d\u0435\u0442 \u0438\u0437 \u044d\u0442\u043e\u0433\u043e \u0441\u043f\u0438\u0441\u043a\u0430.',
  deleted: '\u0411\u043e\u0442 @%{username} \u0443\u0434\u0430\u043b\u0435\u043d.',
  open: '\u041e\u0442\u043a\u0440\u044b\u0442\u044c',
  refreshWebhook:
    '\u041e\u0431\u043d\u043e\u0432\u0438\u0442\u044c webhook',
};

const stepLabels = {
  telegram_getme:
    '\u041f\u0440\u043e\u0432\u0435\u0440\u044f\u0435\u043c token',
  chatwoot_inbox:
    '\u0421\u043e\u0437\u0434\u0430\u0435\u043c \u0438\u0441\u0442\u043e\u0447\u043d\u0438\u043a',
  database:
    '\u0421\u043e\u0445\u0440\u0430\u043d\u044f\u0435\u043c gateway',
  telegram_webhook:
    '\u0412\u043a\u043b\u044e\u0447\u0430\u0435\u043c webhook',
};

const bots = ref([]);
const isLoading = ref(true);
const isSaving = ref(false);
const error = ref('');
const notice = ref('');
const botToken = ref('');
const brandName = ref('');
const tokenInput = ref(null);
const steps = ref([]);
const deletingBotId = ref('');

const emptySteps = () =>
  Object.keys(stepLabels).map(key => ({ key, status: 'pending', detail: '' }));

steps.value = emptySteps();

const accountId = computed(() => route.params.accountId);
const botCount = computed(() => bots.value.length);
const doneCount = computed(
  () => steps.value.filter(item => item.status === 'done').length
);
const showProgress = computed(
  () => isSaving.value || steps.value.some(item => item.status !== 'pending')
);
const progressWidth = computed(() => {
  if (!steps.value.length) return '0%';
  return `${Math.max(8, Math.round((doneCount.value / steps.value.length) * 100))}%`;
});

const authHeaders = () => {
  const data = Auth.getAuthData() || {};
  return {
    'access-token': data['access-token'] || '',
    'token-type': data['token-type'] || 'Bearer',
    client: data.client || '',
    expiry: data.expiry || '',
    uid: data.uid || '',
  };
};

const gatewayPath = path =>
  `/gateway_support/accounts/${accountId.value}/telegram-bots${path}`;

const request = async (path, options = {}) => {
  const response = await fetch(gatewayPath(path), {
    credentials: 'same-origin',
    ...options,
    headers: {
      ...authHeaders(),
      'Content-Type': 'application/json',
      ...(options.headers || {}),
    },
  });
  const payload = await response.json().catch(() => ({}));
  if (!response.ok) {
    throw {
      code: payload.error || 'request_failed',
      stage: payload.stage || '',
      steps: payload.steps || [],
    };
  }
  return payload;
};

const loadBots = async () => {
  isLoading.value = true;
  error.value = '';
  try {
    const payload = await request('/bots');
    bots.value = payload.bots || [];
  } catch (e) {
    error.value = readableError(e.code || e.message);
  } finally {
    isLoading.value = false;
  }
};

const focusCreate = () => {
  tokenInput.value?.focus();
};

const setLocalStep = key => {
  const currentIndex = steps.value.findIndex(item => item.key === key);
  steps.value = steps.value.map((item, itemIndex) => {
    if (item.key === key) return { ...item, status: 'running' };
    if (itemIndex < currentIndex) return { ...item, status: 'done' };
    return item;
  });
};

const syncServerSteps = serverSteps => {
  if (!serverSteps?.length) return;
  steps.value = emptySteps().map(item => {
    const serverItem = serverSteps.find(step => step.key === item.key);
    return serverItem ? { ...item, ...serverItem } : item;
  });
};

const resetForm = () => {
  botToken.value = '';
  brandName.value = '';
  steps.value = emptySteps();
};

const createBot = async () => {
  if (!botToken.value.trim()) {
    error.value = readableError('bot_token_required');
    focusCreate();
    return;
  }

  isSaving.value = true;
  error.value = '';
  notice.value = '';
  steps.value = emptySteps();

  const timers = [
    setTimeout(() => setLocalStep('telegram_getme'), 80),
    setTimeout(() => setLocalStep('chatwoot_inbox'), 600),
    setTimeout(() => setLocalStep('database'), 1200),
    setTimeout(() => setLocalStep('telegram_webhook'), 1800),
  ];

  try {
    const payload = await request('/bots', {
      method: 'POST',
      body: JSON.stringify({
        bot_token: botToken.value.trim(),
        brand_name: brandName.value.trim(),
      }),
    });
    syncServerSteps(payload.steps);
    notice.value = payload.already_existed
      ? `@${payload.bot_username} \u0443\u0436\u0435 \u043f\u043e\u0434\u043a\u043b\u044e\u0447\u0435\u043d.`
      : `@${payload.bot_username} \u0418\u0441\u0442\u043e\u0447\u043d\u0438\u043a \u0433\u043e\u0442\u043e\u0432.`;
    resetForm();
    await loadBots();
  } catch (e) {
    syncServerSteps(e.steps);
    error.value = readableError(e.code, e.stage);
  } finally {
    timers.forEach(clearTimeout);
    isSaving.value = false;
  }
};

const refreshWebhook = async bot => {
  error.value = '';
  try {
    await request(`/bots/${encodeURIComponent(bot.bot_id)}/refresh-webhook`, {
      method: 'POST',
    });
    notice.value = `Webhook @${bot.bot_username} \u043e\u0431\u043d\u043e\u0432\u043b\u0435\u043d.`;
    setTimeout(() => (notice.value = ''), 2500);
  } catch (e) {
    error.value = readableError(e.code || e.message);
  }
};

const deleteBot = async bot => {
  const username = bot.bot_username || bot.bot_id;
  if (!window.confirm(copy.deleteConfirm.replace('%{username}', username))) return;
  error.value = '';
  notice.value = '';
  deletingBotId.value = bot.bot_id;
  try {
    await request(`/bots/${encodeURIComponent(bot.bot_id)}`, {
      method: 'DELETE',
    });
    notice.value = copy.deleted.replace('%{username}', username);
    await loadBots();
  } catch (e) {
    error.value = readableError(e.code || e.message);
  } finally {
    deletingBotId.value = '';
  }
};

const readableError = (code, stage = '') => {
  const where = stage && stepLabels[stage] ? `${stepLabels[stage]}: ` : '';
  const messages = {
    invalid_bot_token:
      'Telegram \u043d\u0435 \u043f\u0440\u0438\u043d\u044f\u043b token. \u041f\u0440\u043e\u0432\u0435\u0440\u044c\u0442\u0435, \u0447\u0442\u043e \u043e\u043d \u043e\u0442 @BotFather.',
    bot_token_required:
      '\u0412\u0441\u0442\u0430\u0432\u044c\u0442\u0435 Bot Token \u043e\u0442 @BotFather.',
    not_a_bot:
      '\u042d\u0442\u043e\u0442 token \u043d\u0435 \u043f\u0440\u0438\u043d\u0430\u0434\u043b\u0435\u0436\u0438\u0442 Telegram-\u0431\u043e\u0442\u0443.',
    forbidden:
      '\u0420\u0430\u0437\u0434\u0435\u043b \u0434\u043e\u0441\u0442\u0443\u043f\u0435\u043d \u0442\u043e\u043b\u044c\u043a\u043e \u0430\u0434\u043c\u0438\u043d\u0438\u0441\u0442\u0440\u0430\u0442\u043e\u0440\u0443 Chatwoot.',
    bot_not_found:
      '\u0411\u043e\u0442 \u0443\u0436\u0435 \u0443\u0434\u0430\u043b\u0435\u043d \u0438\u043b\u0438 \u043d\u0435 \u043d\u0430\u0439\u0434\u0435\u043d.',
    gateway_proxy_not_configured:
      'Chatwoot \u043d\u0435 \u043d\u0430\u0441\u0442\u0440\u043e\u0435\u043d \u043d\u0430 \u0441\u0432\u044f\u0437\u044c \u0441 gateway.',
    chatwoot_bootstrap_not_configured:
      'Gateway \u043d\u0435 \u043d\u0430\u0441\u0442\u0440\u043e\u0435\u043d \u043d\u0430 \u0441\u043e\u0437\u0434\u0430\u043d\u0438\u0435 \u0438\u0441\u0442\u043e\u0447\u043d\u0438\u043a\u043e\u0432 Chatwoot.',
    chatwoot_inbox_failed:
      'Chatwoot \u043d\u0435 \u0441\u043e\u0437\u0434\u0430\u043b \u0438\u0441\u0442\u043e\u0447\u043d\u0438\u043a.',
    db_write_failed:
      'Gateway \u043d\u0435 \u0441\u043c\u043e\u0433 \u0441\u043e\u0445\u0440\u0430\u043d\u0438\u0442\u044c \u0431\u043e\u0442\u0430 \u0432 \u0431\u0430\u0437\u0435.',
    encryption_failed:
      'Gateway \u043d\u0435 \u0441\u043c\u043e\u0433 \u0437\u0430\u0448\u0438\u0444\u0440\u043e\u0432\u0430\u0442\u044c \u0441\u0435\u043a\u0440\u0435\u0442\u044b.',
    public_base_url_not_configured:
      'Gateway \u043d\u0435 \u0437\u043d\u0430\u0435\u0442 \u043f\u0443\u0431\u043b\u0438\u0447\u043d\u044b\u0439 URL \u0434\u043b\u044f webhook.',
    telegram_webhook_failed:
      'Telegram \u043d\u0435 \u043f\u0440\u0438\u043d\u044f\u043b webhook.',
  };
  return `${where}${messages[code] || `\u041e\u0448\u0438\u0431\u043a\u0430: ${code || 'request_failed'}`}`;
};

onMounted(loadBots);
</script>

<template>
  <section class="tg-bots-page">
    <header class="tg-bots-header">
      <div class="tg-bots-title">
        <h1>{{ copy.title }}</h1>
        <p>{{ copy.subtitle }}</p>
      </div>
      <div class="tg-bots-actions">
        <button type="button" class="cw-button ghost" @click="loadBots">
          <span class="i-lucide-refresh-cw icon" />
          {{ copy.refresh }}
        </button>
        <button type="button" class="cw-button primary" @click="focusCreate">
          <span class="i-lucide-plus icon" />
          {{ copy.newBot }}
        </button>
      </div>
    </header>

    <div v-if="error" class="alert error">
      <span class="i-lucide-circle-alert icon" />
      <span>{{ error }}</span>
    </div>
    <div v-if="notice" class="alert success">
      <span class="i-lucide-circle-check icon" />
      <span>{{ notice }}</span>
    </div>

    <div class="tg-bots-grid">
      <section class="panel list-panel">
        <div class="panel-head">
          <h2>{{ copy.sources }}</h2>
          <span class="count-pill">{{ botCount }} {{ copy.countSuffix }}</span>
        </div>

        <div v-if="isLoading" class="loading-list">
          <span v-for="item in 4" :key="item" />
        </div>

        <div v-else-if="!bots.length" class="empty-state">
          <span class="i-lucide-bot icon" />
          <strong>{{ copy.emptyTitle }}</strong>
          <p>{{ copy.emptyText }}</p>
        </div>

        <ul v-else class="bot-list">
          <li v-for="bot in bots" :key="bot.bot_id" class="bot-row">
            <div class="bot-avatar">
              <span class="i-lucide-bot icon" />
            </div>
            <div class="bot-main">
              <strong>{{ bot.brand_name || bot.bot_username || bot.bot_id }}</strong>
              <span>@{{ bot.bot_username || bot.bot_id }}</span>
              <div class="bot-tags">
                <span class="tag active">{{ bot.status || copy.connected }}</span>
                <span class="tag source">{{ bot.source }}</span>
                <span v-if="bot.chatwoot_inbox_id" class="tag inbox">
                  inbox #{{ bot.chatwoot_inbox_id }}
                </span>
              </div>
            </div>
            <div class="bot-actions">
              <button
                type="button"
                class="icon-button"
                :title="copy.refreshWebhook"
                :disabled="deletingBotId === bot.bot_id"
                @click="refreshWebhook(bot)"
              >
                <span class="i-lucide-rotate-cw icon" />
              </button>
              <button
                type="button"
                class="icon-button danger"
                :title="copy.delete"
                :disabled="deletingBotId === bot.bot_id"
                @click="deleteBot(bot)"
              >
                <span
                  :class="deletingBotId === bot.bot_id ? 'i-lucide-loader-circle spin icon' : 'i-lucide-trash-2 icon'"
                />
              </button>
            </div>
          </li>
        </ul>
      </section>

      <aside class="panel create-panel">
        <div class="panel-head stacked">
          <div>
            <h2>{{ copy.createTitle }}</h2>
            <p>{{ copy.createHint }}</p>
          </div>
        </div>

        <form class="create-form" @submit.prevent="createBot">
          <input
            ref="tokenInput"
            v-model="botToken"
            class="cw-input"
            type="password"
            autocomplete="off"
            spellcheck="false"
            :placeholder="copy.tokenPlaceholder"
            :disabled="isSaving"
          />
          <input
            v-model="brandName"
            class="cw-input"
            type="text"
            autocomplete="off"
            :placeholder="copy.brandPlaceholder"
            :disabled="isSaving"
          />
          <button
            type="submit"
            class="cw-button primary wide"
            :disabled="isSaving"
          >
            <span
              :class="isSaving ? 'i-lucide-loader-circle spin icon' : 'i-lucide-plus icon'"
            />
            {{ copy.createButton }}
          </button>
        </form>

        <div v-if="showProgress" class="progress-card">
          <div class="progress-head">
            <strong>{{ copy.progressTitle }}</strong>
            <span>{{ doneCount }}/{{ steps.length }}</span>
          </div>
          <div class="progress-track">
            <span :style="{ width: progressWidth }" />
          </div>
          <ol class="step-list">
            <li
              v-for="step in steps"
              :key="step.key"
              :class="['step-row', step.status]"
            >
              <span class="step-dot" />
              <div>
                <strong>{{ stepLabels[step.key] }}</strong>
                <small>
                  {{
                    step.status === 'done'
                      ? copy.done
                      : step.status === 'failed'
                        ? copy.error
                        : copy.pending
                  }}
                </small>
              </div>
            </li>
          </ol>
        </div>
      </aside>
    </div>
  </section>
</template>

<style scoped>
.tg-bots-page {
  box-sizing: border-box;
  min-height: 100vh;
  height: auto;
  overflow: visible;
  padding: 18px 20px 32px;
  color: #f8fafc;
  background:
    radial-gradient(circle at top right, rgb(37 99 235 / 18%), transparent 30rem),
    #111318;
  font-family:
    Inter,
    ui-sans-serif,
    system-ui,
    -apple-system,
    BlinkMacSystemFont,
    "Segoe UI",
    sans-serif;
}

.tg-bots-header,
.tg-bots-grid,
.alert {
  width: 100%;
  max-width: 1440px;
  margin: 0 auto;
}

.tg-bots-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 16px;
  margin-bottom: 16px;
}

.tg-bots-title h1,
.panel-head h2 {
  margin: 0;
  letter-spacing: 0;
}

.tg-bots-title h1 {
  font-size: 22px;
  font-weight: 700;
  color: #f8fafc;
}

.tg-bots-title p,
.panel-head p,
.empty-state p {
  margin: 4px 0 0;
  color: #94a3b8;
  font-size: 13px;
  line-height: 1.45;
}

.tg-bots-actions,
.bot-actions {
  display: flex;
  align-items: center;
  gap: 8px;
}

.tg-bots-grid {
  display: grid;
  grid-template-columns: minmax(0, 1fr) 360px;
  gap: 16px;
  align-items: start;
}

.panel {
  min-width: 0;
  overflow: hidden;
  border: 1px solid #293140;
  border-radius: 8px;
  background: #181b23;
  box-shadow: 0 16px 48px rgb(0 0 0 / 22%);
}

.panel-head {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  padding: 14px 16px;
  border-bottom: 1px solid #293140;
}

.panel-head.stacked {
  align-items: flex-start;
}

.panel-head h2 {
  color: #f8fafc;
  font-size: 14px;
  font-weight: 700;
}

.count-pill,
.tag {
  display: inline-flex;
  align-items: center;
  min-height: 18px;
  padding: 0 7px;
  border-radius: 999px;
  font-size: 10px;
  font-weight: 700;
  line-height: 18px;
}

.count-pill {
  color: #cbd5e1;
  background: #222938;
}

.bot-list {
  display: flex;
  flex-direction: column;
  margin: 0;
  padding: 0;
  list-style: none;
  overflow: visible;
  overscroll-behavior: contain;
}

.bot-row {
  display: grid;
  grid-template-columns: 34px minmax(0, 1fr) max-content;
  column-gap: 12px;
  align-items: center;
  min-height: 66px;
  padding: 9px 14px;
  border-bottom: 1px solid #293140;
  transition:
    background 160ms ease,
    border-color 160ms ease;
}

.bot-row:last-child {
  border-bottom: 0;
}

.bot-row:hover {
  background: #1d2230;
}

.bot-avatar {
  display: grid;
  place-items: center;
  width: 34px;
  height: 34px;
  min-width: 34px;
  color: #7dd3fc;
  border: 1px solid #2f3a4f;
  border-radius: 8px;
  background: #1f2a3d;
}

.bot-main {
  display: grid;
  align-content: center;
  gap: 3px;
  min-width: 0;
}

.bot-main strong,
.bot-main span {
  display: block;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.bot-main strong {
  color: #f8fafc;
  font-size: 13px;
  line-height: 1.2;
}

.bot-main > span {
  color: #94a3b8;
  font-size: 11px;
  line-height: 1.25;
}

.bot-tags {
  display: flex;
  flex-wrap: wrap;
  gap: 4px;
  margin-top: 1px;
}

.tag.active {
  color: #052e16;
  background: #86efac;
}

.tag.source {
  color: #dbeafe;
  background: #1d4ed8;
}

.tag.inbox {
  color: #082f49;
  background: #7dd3fc;
}

.cw-button,
.icon-button {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  border: 0;
  border-radius: 8px;
  font-weight: 700;
  line-height: 1;
  cursor: pointer;
  transition:
    transform 140ms ease,
    background 140ms ease,
    color 140ms ease,
    border-color 140ms ease;
}

.cw-button {
  gap: 8px;
  min-height: 38px;
  padding: 0 14px;
  font-size: 13px;
}

.cw-button:hover,
.icon-button:hover {
  transform: translateY(-1px);
}

.cw-button:disabled,
.cw-input:disabled,
.icon-button:disabled {
  cursor: not-allowed;
  opacity: 0.62;
}

.cw-button.primary {
  color: #ffffff;
  background: #2563eb;
}

.cw-button.primary:hover {
  background: #1d4ed8;
}

.cw-button.ghost,
.icon-button {
  color: #cbd5e1;
  border: 1px solid #334155;
  background: #1f2430;
}

.cw-button.ghost:hover,
.icon-button:hover {
  color: #f8fafc;
  background: #283246;
}

.cw-button.wide {
  width: 100%;
}

.icon-button {
  flex: 0 0 34px;
  width: 34px;
  min-width: 34px;
  height: 34px;
  min-height: 34px;
  padding: 0;
}

.icon-button.danger {
  color: #fecaca;
  border-color: #7f1d1d;
  background: #37151a;
}

.icon-button.danger:hover {
  color: #ffffff;
  background: #dc2626;
}

.icon {
  width: 16px;
  height: 16px;
}

.create-form {
  display: flex;
  flex-direction: column;
  gap: 10px;
  padding: 16px;
}

.cw-input {
  width: 100%;
  height: 40px;
  padding: 0 12px;
  color: #f8fafc;
  border: 1px solid #334155;
  border-radius: 8px;
  outline: none;
  background: #10141d;
  font-size: 13px;
  transition:
    border-color 140ms ease,
    box-shadow 140ms ease,
    background 140ms ease;
}

.cw-input::placeholder {
  color: #64748b;
}

.cw-input:focus {
  border-color: #3b82f6;
  box-shadow: 0 0 0 3px rgb(59 130 246 / 22%);
  background: #0f1724;
}

.alert {
  display: flex;
  align-items: center;
  gap: 8px;
  min-height: 40px;
  margin-bottom: 12px;
  padding: 10px 12px;
  border-radius: 8px;
  font-size: 13px;
  font-weight: 600;
}

.alert.error {
  color: #fecaca;
  border: 1px solid #7f1d1d;
  background: #2b1418;
}

.alert.success {
  color: #bbf7d0;
  border: 1px solid #166534;
  background: #102719;
}

.empty-state {
  display: grid;
  place-items: center;
  min-height: 260px;
  padding: 32px;
  text-align: center;
  color: #cbd5e1;
}

.empty-state .icon {
  width: 36px;
  height: 36px;
  margin-bottom: 12px;
  color: #60a5fa;
}

.loading-list {
  display: flex;
  flex-direction: column;
  gap: 1px;
  padding: 0;
}

.loading-list span {
  display: block;
  height: 82px;
  background: linear-gradient(90deg, #181b23, #222938, #181b23);
  background-size: 200% 100%;
  animation: shimmer 1.1s linear infinite;
}

.progress-card {
  margin: 0 16px 16px;
  padding: 14px;
  border: 1px solid #2f3a4f;
  border-radius: 8px;
  background: #111827;
}

.progress-head {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 10px;
  color: #f8fafc;
  font-size: 13px;
}

.progress-track {
  overflow: hidden;
  height: 6px;
  border-radius: 999px;
  background: #263244;
}

.progress-track span {
  display: block;
  height: 100%;
  border-radius: inherit;
  background: #3b82f6;
  transition: width 260ms ease;
}

.step-list {
  display: flex;
  flex-direction: column;
  gap: 10px;
  margin: 14px 0 0;
  padding: 0;
  list-style: none;
}

.step-row {
  display: grid;
  grid-template-columns: 12px 1fr;
  gap: 10px;
  align-items: start;
}

.step-dot {
  width: 10px;
  height: 10px;
  margin-top: 4px;
  border-radius: 999px;
  background: #475569;
}

.step-row.running .step-dot {
  background: #60a5fa;
  box-shadow: 0 0 0 5px rgb(96 165 250 / 12%);
}

.step-row.done .step-dot {
  background: #22c55e;
}

.step-row.failed .step-dot {
  background: #ef4444;
}

.step-row strong,
.step-row small {
  display: block;
}

.step-row strong {
  color: #f8fafc;
  font-size: 12px;
}

.step-row small {
  margin-top: 2px;
  color: #94a3b8;
  font-size: 11px;
}

.spin {
  animation: spin 800ms linear infinite;
}

@keyframes spin {
  to {
    transform: rotate(360deg);
  }
}

@keyframes shimmer {
  to {
    background-position: -200% 0;
  }
}

@media (max-width: 1180px) {
  .tg-bots-page {
    padding: 16px;
  }

  .tg-bots-header {
    align-items: flex-start;
    flex-direction: column;
  }

  .tg-bots-grid {
    grid-template-columns: 1fr;
  }

  .create-panel {
    order: -1;
  }
}

@media (max-width: 640px) {
  .tg-bots-actions {
    width: 100%;
  }

  .tg-bots-actions .cw-button {
    flex: 1;
  }

  .bot-row {
    grid-template-columns: 34px minmax(0, 1fr) max-content;
    padding: 9px 12px;
  }

  .bot-actions {
    justify-content: flex-end;
  }
}

@media (max-width: 520px) {
  .bot-row {
    grid-template-columns: 34px minmax(0, 1fr);
  }

  .bot-actions {
    grid-column: 2;
    justify-content: flex-start;
  }
}
</style>
